import React, { useEffect } from "react";
import Card from "components/card";
import AwardCard from "./AwardCard";
import { connect } from "react-redux";
import { getApprovedAwardList } from "../../../../redux/employeeaward/employeeAwardState"
import { Trophy } from "lucide-react";
import { Pagination } from "antd";


const Awards = ({ 
  recordList, 
  pagination, 
  doSearch,
  filters
}) => {

  useEffect(() => {
    doSearch({ paginate: pagination.per_page });
  }, [doSearch, pagination.per_page]);

  return (
    <Card className="flex flex-col gap-6 rounded-2xl border border-purple-200">
      <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6">
        <h4 className="leading-none flex items-center gap-2 title-text">
          <Trophy className="w-5 h-5 text-amber-600 dark:text-amber-500" />
          My Awards
        </h4>
        <p className="muted-text">Your achievements and recognition badges</p>
      </div>

      <div className="px-6 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {recordList?.map((award) => (
            <AwardCard
              key={award.ema_id}
              recordData={award}
            />
          ))}

          {pagination?.total > pagination?.per_page && (
            <div className="flex justify-end py-4">
              <Pagination
                current={pagination?.current_page}
                pageSize={pagination?.per_page}
                total={pagination?.total}
                showSizeChanger={false}
                onChange={(page) =>
                  doSearch({
                    ...filters,
                    page,
                    paginate: pagination?.per_page,
                  })
                }
              />
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.employeeAward.approvedAwardList?.items,
  pagination: state.employeeAward.approvedAwardList?.pagination,
  requesting: state.employeeAward.approvedAwardList?.requesting,
  filters: state.employeeAward.approvedAwardList?.filters,
  error: state.employeeAward.approvedAwardList?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getApprovedAwardList(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(Awards);